{
  "general": {
    "title": "Title"
  },
  "header": {
    "language": "Language",
    "help": "Help",
    "help_modal": {
      "description": "If you require assistance or have any questions you can contact us by email at {mail} or by phone at {phone}."
    }
  },
  "fields": {
    "error_message": "This field is required",
    "invalid_email": "Invalid email address",
    "invalid_end": "End time should be after start time",
    "terms_required": "You have to agree to the Terms and Conditions to continue",
    "invalid_phone": "Invalid phone number. Try adding the country code",
    "function_space_required": "Please select a function space to continue",
    "function_space_configuration_error": "No function spaces can accommodate your selected configuration. Please adjust the number of guests or setup type.",
    "function_space_date_unavailable": "Function spaces that fit your requirements are not available on the selected date. Please choose a different date.",
    "function_space_conflict_error": "This function space is already selected for an overlapping time period. Please choose a different space or adjust the time.",
    "required": "This field is required"
  },
  "reservation_steps": {
    "title": "Your Booking:",
    "step_1": {
      "title": "Booking Details",
      "sub_steps": {
        "services": "Services Required",
        "location": "Property Selection",
        "email": "Contact Details"
      }
    },
    "step_2": {
      "title": "Meeting Spaces",
      "sub_steps": {
        "basic_information_meeting_rooms": "Your Event",
        "days": "Event Details",
        "remarks": "Remarks"
      }
    },
    "step_3": {
      "title": "Guest Rooms",
      "title_with_date": "Guest Rooms for {date}",
      "sub_steps": {
        "basic_information_hotel_rooms": "Details"
      }
    },
    "step_4": {
      "title": "Contact Details",
      "sub_steps": {
        "basic_information": "Account Details",
        "contact_person": "Billing Address"
      }
    },
    "step_5": {
      "title": "Booking Summary"
    }
  },
  "reservation_form": {
    "step_1": {
      "services": {
        "title": "Services Required",
        "mice": "Meeting Spaces",
        "hotel": "Guest Rooms"
      },
      "location": {
        "title": "Property Selection",
        "address": "Address",
        "phonenumber": "Phone Number"
      },
      "contract_email": {
        "title": "Contact Details",
        "field": "Email Address"
      }
    },
    "step_2": {
      "basic_information": {
        "title": "Your Event",
        "description_header": "",
        "description": "Please select the days your event takes place. You can select multiple days and change the details per day.",
        "fields": {
          "event_name": "Event Name",
          "event_type": "Event Type",
          "number_of_guests": "Number of Guests",
          "start_time": "Start Time",
          "end_time": "End Time",
          "amount": "Amount",
          "total": "Total",
          "add": "Add",
          "emplacement": "Setup"
        }
      },
      "add_day": {
        "title": "Do you want to add another day?",
        "add_day": "Add Day",
        "add_item": "Add Product",
        "day": "Day {dayCount}",
        "date": "Date",
        "select_date": "Select Date",
        "select_date_description": "This is {day} of your event. You can modify the details for this day below.",
        "plenary_hall": "Function Space",
        "sub_hall": "Sub Space",
        "add_hall_description": "For adding more function spaces to this day, click on the add function space button",
        "add_hall_required": "Since your package does not include a function space, you must add at least one",
        "add_hall_required_error": "Please add at least one function space to continue",
        "add_hall_button": "Add Function Space",
        "package_deal": "Available Packages",
        "package_deal_chosen": "Selected Package",
        "package_deal_available": "Available Packages",
        "package_deal_items": "Additional Products",
        "package_deal_items_included": "See Included Products",
        "package_deal_spaces_included": "Included Function Spaces",
        "additional_items": "Additional Products",
        "search": "Search",
        "no_items_found": "No products found",
        "choose_package_deal": "Choose",
        "deselect_package_deal": "Remove"
      },
      "remarks": {
        "title": "Remarks"
      },
      "item_types": {
        "audiovisual": "Audiovisual",
        "food_beverage": "Food & Beverages",
        "other": "Other"
      },
      "item_examples": {
        "audiovisual": "For example: Microphones",
        "food_beverage": "For example: Snacks",
        "other": "For example: Flowers"
      },
      "clone_day": "Clone Day",
      "space_selector": {
        "show_spaces": "Choose a Function Space",
        "hide_spaces": "Hide Function Spaces",
        "no_selection": "We will select a suitable function space for you based on the above input.",
        "capacities": "Capacity per Setup",
        "space_not_available": "Not Available",
        "space_already_selected": "Already Selected",
        "space_selected": "Selected",
        "select_space": "Select",
        "show_more": "Show More Spaces",
        "show_less": "Show Less Spaces",
        "show_unavailable": "Show Unavailable Spaces",
        "hide_unavailable": "Hide Unavailable Spaces",
        "unavailable_matching_spaces": "Spaces That Match Your Requirements But Are Not Available",
        "no_image": "No Photo Available"
      }
    },
    "step_3": {
      "booking": {
        "title": "Guest Rooms",
        "title_with_date": "Guest Rooms for {date}",
        "available": "Available",
        "unavailable": "Not Available",
        "available_rooms": "{n} available",
        "quantity": "Quantity",
        "guests_per_room": "Guests per room",
        "guests_per_room_with_max": "Guests per room (max {max})",
        "max_guests": "Max {n} guests",
        "fields": {
          "name": "Group Name",
          "check_in_date": "Check-in",
          "check_out_date": "Check-out",
          "property": "Guest Room Property",
          "number_of_rooms": "Quantity",
          "persons_per_room": "Room Guests",
          "total_guests": "Total Guests",
          "room_type": "Room Type",
          "late_check_out": "Late check-out",
          "late_check_out_rooms": "Late check-out rooms",
          "breakfast": "Breakfast",
          "remarks": "Remarks"
        },
        "progress_selected": "Selected",
        "max_capacity": "Max {count} guests",
        "sections": {
          "property": "Property Selection",
          "details": "Booking Details", 
          "room_selection": "Room Selection"
        },
        "collapsed_summary": "{selected}/{total} rooms selected for {date}",
        "completed": "Complete",
        "too_many_selected": "Too many selected",
        "incomplete": "Incomplete"
      },
      "overnight_stay": {
        "title": "Do you want another overnight stay?",
        "button": "Add Overnight Stay",
        "day": "Overnight stay"
      },
      "clone_room": "Clone overnight stay"
    },
    "step_4": {
      "account_details": {
        "title": "Account Details",
        "fields": {
          "first_name": "First Name",
          "last_name": "Last Name",
          "company_name": "Company",
          "email_address": "Email Address",
          "phone_number": "Phone Number"
        }
      },
      "billing_address": {
        "title": "Billing Address",
        "fields": {
          "address": "Address",
          "postal_code": "Postal Code",
          "city": "City",
          "country": "Country"
        }
      },
      "contact_person_location": {
        "title": "Contact Person on Location",
        "fields": {
          "copy": "Copy from Account Details"
        }
      },
      "discount_code": "Promo code",
      "invoice_reference": "Invoice Reference"
    },
    "step_5": {
      "offer": "Your Offer",
      "reservation": "Your Reservation",
      "request": "Your Booking",
      "offer_details": "You can check all the details here. Also view the suggestions that we have selected for you based on our expertise.",
      "download_pdf": "Download PDF",
      "hotel_only_meeting": "stay",
      "discount": "Discount",
      "remarks": "Remarks",
      "payment_method": "Payment Method",
      "payment_done": "Payment successful",
      "payment_succeeded": "Your booking has been placed. We will send you an email with your details.",
      "payment_waiting": "Payment processing",
      "payment_processing": "Your payment is still being processed. We will send you an email when your payment succeeds.",
      "payment_failed": "Payment failed",
      "payment_failed_message": "Something went wrong while processing your payment. Please try again.",
      "sub_total_exclusive_vat": "Subtotal (excluding VAT)",
      "sub_total_exclusive_sales_tax": "Subtotal (excluding sales tax)",
      "vat_amount": "{vat}% VAT",
      "sales_tax_amount": "{vat}% sales tax",
      "terms_and_conditions": "Terms & Conditions",
      "minutes_left": "Your request will be held for 1 more minute. Please complete your payment soon to secure it. | Your request will be held for <strong>{count} more minutes</strong>. Please complete your payment soon to secure it.",
      "seconds_left": "You have <strong>1 second</strong> left to complete your payment. Your request expires soon. | You have <strong>{count} seconds</strong> left to complete your payment. Your request expires soon.",
      "timer": {
        "title": "Out of time",
        "subtitle": "Sorry, you've run out of time to complete your payment. But no worries, we have your request and will contact you as soon as possible."
      },
      "basic_information": {
        "title": "Booking Details",
        "event_name": "Event Name",
        "event_type": "Event Type"
      },
      "contact_information": {
        "title": "Contact Information",
        "contact_person_location": "Contact Person on Location",
        "account_details": "Account Details",
        "billing_address": "Billing Address"
      },
      "day": {
        "day": "Day {dayCount}",
        "function_spaces": "Function Spaces",
        "additional_function_spaces": "Additional Function Spaces",
        "pax": "Number of guests",
        "emplacement": "Setup",
        "start_time": "Start time",
        "end_time": "End time",
        "package_deals": "Packages",
        "package_deals_details": "The package that is ready for you with the associated items.",
        "package_deals_amount": "1 Person | {count} Persons",
        "package_deals_price": "{amount} per person",
        "additional_items": "Additional Items",
        "total": "Total",
        "vat": "including VAT",
        "sales_tax": "excluding sales tax",
        "hall_rental": {
          "title": "Function space rental",
          "pax": "{pax} persons"
        }
      },
      "hotel_room": {
        "title": "Guest Rooms",
        "price": "Price",
        "room_type": "Room Type",
        "rooms": "Rooms",
        "number_of_rooms": "0 Rooms | 1 Room | {n} Rooms",
        "per_room": "Occupancy",
        "pax_room": "0 Persons per room | 1 Person per room | {n} Persons per room",
        "breakfast_status": "Breakfast included | Breakfast not included",
        "late_checkout": "Late-check-out",
        "nights": "0 nights | 1 night | {n} nights",
        "per_night": "{amount} per room per night",
        "breakfast_price": "{name}: {amount} per person per night",
        "late_checkout_price": "Late checkout: {amount} per room",
        "city_tax": "Excluding city tax",
        "guests": "Guests",
        "number_of_guests": "0 Guests | 1 Guest | {n} Guests"
      },
      "multi_venue_alert": {
        "title": "Multi-venue booking",
        "description": "Guest rooms are booked at different venue(s). See details below."
      }
    },
    "modal": {
      "confirm_turn_down": {
        "title": "Are You Sure You Want to Turn Down This Offer?",
        "body": "This cannot be undone.",
        "checkbox": "I accept that I am turning down this offer irrevocably."
      },
      "confirm_cancel": {
        "title": "Are You Sure You Want to Cancel This Reservation?",
        "body": "Terms and conditions apply.",
        "checkbox": "I have read, understood, and agree to the <a href='{termsUrl}' target='_blank'>Terms & Conditions</a>."
      },
      "confirm_accept": {
        "title": "Confirm Your Reservation",
        "body": "Terms and conditions apply.",
        "checkbox": "I have read, understood, and agree to the <a href='{termsUrl}' target='_blank'>Terms & Conditions</a>."
      },
      "reservation_edited": {
        "title": "Thank You Very Much. Your Changes Have Been Applied."
      },
      "reservation_submitted": {
        "title": "Thank You Very Much. It's Great to See Your Interest in Organizing Your {meeting} With Us.",
        "body": "You will receive an offer for your reservation as soon as possible.",
        "button": "Click Here to Visit the {locationName} Website"
      },
      "reservation_accepted": {
        "body": "You will receive a confirmation of your reservation as soon as possible."
      },
      "reservation_cancelled": {
        "title": "You Have Cancelled the Reservation for Your {meeting}."
      },
      "reservation_turned_down": {
        "title": "You Have Turned Down the Offer for Your {meeting}."
      },
      "cancel_reason": {
        "text": "Cancellation Reason",
        "placeholder": "Please specify why you are cancelling this reservation."
      },
      "turn_down_reason": {
        "text": "Reason for Turning Down",
        "placeholder": "Please specify why you are turning down this offer."
      },
      "submitting": {
        "title": "We Are Submitting Your Request",
        "subtitle": "This can take a while. Please do not close this window."
      },
      "request": {
        "loading_title": "We Are Creating Your Optional Booking",
        "submitted_text": "You will receive an offer for your booking as soon as possible."
      },
      "inquire": {
        "loading_title": "We Are Creating Your Inquiry",
        "submitted_text": "We will reach out to you as soon as possible."
      },
      "book": {
        "loading_title": "We Are Calculating the Price",
        "submitted_text": ""
      }
    },
    "buttons": {
      "edit_reservation": "Edit Reservation",
      "save_pdf": "Save Offer as PDF",
      "submit_offer": "Request Offer",
      "next_step": "Next Step",
      "previous_step": "Previous Step",
      "accept_offer": "Accept Offer",
      "cancel_offer": "Cancel Reservation",
      "turn_down_offer": "Turn Down Offer",
      "edit_offer": "Apply Changes",
      "request_proposal": "Request Proposal",
      "request": "Request Proposal",
      "inquire": "Inquire",
      "book": "Book Now",
      "accept_booking": "Confirm Booking",
      "pay_booking": "Pay",
      "cancel_booking": "Cancel Reservation"
    },
    "basket": {
      "cart": "Price preview",
      "event": "Event",
      "hotel_rooms": "Guest rooms",
      "estimated_fees": "Estimated fees",
    "event_subtotal": "Event subtotal",
    "hotel_room_subtotal": "Guest room subtotal",
      "guests": "guests",
      "meeting_space": "Meeting space",
      "additional_services": "Additional services",
      "room": "room",
      "rooms": "rooms",
      "tax_breakdown": "Tax breakdown",
      "subtotal_with_rate": "Subtotal ({rate}% VAT)",
      "vat_with_rate": "VAT ({rate}%)",
      "sales_tax_with_rate": "Sales tax ({rate}%)",
      "total_excluding_tax": "Total excluding VAT",
      "total_excluding_sales_tax": "Total excluding sales tax",
      "total_tax": "Total VAT",
      "total_sales_tax": "Total sales tax",
      "total_including_taxes": "Total including VAT",
      "total_including_sales_taxes": "Total including sales tax",
      "empty_cart": "Add items to your booking to see pricing details.",
      "pricing_unavailable": "Pricing preview is not available for this booking. You will receive detailed pricing information after completing your booking request."
    }
  },
  "dropdown": {
    "no_results": "No Results Found",
    "placeholder": "Select Option",
    "loading": "Loading..."
  },
  "switch": {
    "yes": "Yes",
    "no": "No"
  },
  "enums": {
    "payment_method": {
      "AT_LOCATION": "On Location",
      "CREDIT_CARD": "Credit Card",
      "INVOICE": "Invoice",
      "PRE_PAYMENT": "Pre Payment",
      "VOUCHER": "Voucher"
    }
  },
  "price_types": {
    "per_guest": "Per Guest",
    "per_unit": "Per Unit",
    "per_guest_explanation": "Base price: {price} per guest. Total shown includes all guests.",
    "per_unit_explanation": "Fixed price: {price} per unit. Not affected by number of guests."
  }
}